import {HTMLProps} from 'react';
import clsx from 'clsx';

type Props = HTMLProps<HTMLHeadingElement> & {
  dataTestid?: string;
};

const Title = ({className, children, dataTestid, ...props}: Props) => {
  return (
    <h1
      data-testid={dataTestid}
      className={clsx('text-lg font-semibold leading-none text-black', className)}
      {...props}
    >
      {children}
    </h1>
  );
};

export default Title;
